import { defineComponent as _defineComponent } from 'vue'

import { computed, defineComponent, onMounted, ref } from "@nuxtjs/composition-api";

import { useAuth, useVuetify } from "@/composables";

const __default__ = defineComponent({
  name: "JourneyGuidance",
  head: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const journeyGuidanceDelay = 5000;
const dismissedJourneyGuidance = "dismissedJourneyGuidance";

const showJourneyGuidance = ref(false);
const journeyGuidanceNotDismissed = ref(false);

const auth = useAuth();
const vuetify = useVuetify();

const isMobile = computed(() => vuetify.breakpoint.xsOnly);

/**
 * Close journey guidance and dismiss moving forward
 */
const onJourneyGuidanceClose = () => {
  showJourneyGuidance.value = false;
  localStorage.setItem(dismissedJourneyGuidance, "true");
};

onMounted(() => {
  if (!auth.loggedIn) {
    setTimeout(() => {
      showJourneyGuidance.value = true;
    }, journeyGuidanceDelay);
  }

  if (!localStorage.getItem(dismissedJourneyGuidance)) {
    journeyGuidanceNotDismissed.value = true;
  }
});

return { __sfc: true,journeyGuidanceDelay, dismissedJourneyGuidance, showJourneyGuidance, journeyGuidanceNotDismissed, auth, vuetify, isMobile, onJourneyGuidanceClose }
}

})